import type { RouteLocationNormalized } from 'vue-router'

/**
 * Execute the callback when the route changes/updates.
 */
export default function (cb: (route: RouteLocationNormalized) => void) {
  const route = useRoute()
  watch(
    () => route.fullPath,
    () => cb(route),
  )
}
